// extracted by mini-css-extract-plugin
export default {"container":"styles_container__mTrTs","content":"styles_content__OaDxu","wrapper-main":"styles_wrapper-main__1czn7","scroll":"styles_scroll__0otsL"};